var map = {
	"./arb/common.json": 1596,
	"./arb/farm.json": 1597,
	"./arb/header.json": 1598,
	"./arb/home.json": 1599,
	"./arb/nft.json": 1600,
	"./arb/pool.json": 1601,
	"./arb/referral.json": 1602,
	"./arb/swap.json": 1603,
	"./arb/trading.json": 1604,
	"./cn/common.json": 1605,
	"./cn/farm.json": 1606,
	"./cn/header.json": 1607,
	"./cn/home.json": 1608,
	"./cn/nft.json": 1609,
	"./cn/pool.json": 1610,
	"./cn/referral.json": 1611,
	"./cn/swap.json": 1612,
	"./cn/trading.json": 1613,
	"./dt/common.json": 1614,
	"./dt/farm.json": 1615,
	"./dt/header.json": 1616,
	"./dt/home.json": 1617,
	"./dt/marketplace.json": 1618,
	"./dt/nft.json": 1619,
	"./dt/pool.json": 1620,
	"./dt/referral.json": 1621,
	"./dt/swap.json": 1622,
	"./dt/trading.json": 1623,
	"./en/bondExchange.json": 1624,
	"./en/bondLaunchpad.json": 1625,
	"./en/bonds.json": 1626,
	"./en/bridgeAsset.json": 1627,
	"./en/common.json": 1628,
	"./en/competition.json": 1629,
	"./en/farm.json": 1630,
	"./en/games.json": 1631,
	"./en/governance.json": 1632,
	"./en/header.json": 1633,
	"./en/home.json": 1634,
	"./en/landing.json": 1635,
	"./en/marketplace.json": 1636,
	"./en/nft.json": 1637,
	"./en/pool.json": 1638,
	"./en/referral.json": 1639,
	"./en/swap.json": 1640,
	"./en/trading.json": 1641,
	"./en/vault.json": 1642,
	"./fr/common.json": 1643,
	"./fr/farm.json": 1644,
	"./fr/header.json": 1645,
	"./fr/home.json": 1646,
	"./fr/marketplace.json": 1647,
	"./fr/nft.json": 1648,
	"./fr/pool.json": 1649,
	"./fr/referral.json": 1650,
	"./fr/swap.json": 1651,
	"./fr/trading.json": 1652,
	"./hi/common.json": 1653,
	"./hi/farm.json": 1654,
	"./hi/header.json": 1655,
	"./hi/home.json": 1656,
	"./hi/marketplace.json": 1657,
	"./hi/nft.json": 1658,
	"./hi/pool.json": 1659,
	"./hi/referral.json": 1660,
	"./hi/swap.json": 1661,
	"./hi/trading.json": 1662,
	"./id/common.json": 1663,
	"./id/farm.json": 1664,
	"./id/header.json": 1665,
	"./id/home.json": 1666,
	"./id/marketplace.json": 1667,
	"./id/nft.json": 1668,
	"./id/pool.json": 1669,
	"./id/referral.json": 1670,
	"./id/swap.json": 1671,
	"./id/trading.json": 1672,
	"./jp/common.json": 1673,
	"./jp/farm.json": 1674,
	"./jp/header.json": 1675,
	"./jp/home.json": 1676,
	"./jp/nft.json": 1677,
	"./jp/pool.json": 1678,
	"./jp/referral.json": 1679,
	"./jp/swap.json": 1680,
	"./jp/trading.json": 1681,
	"./por/common.json": 1682,
	"./por/farm.json": 1683,
	"./por/header.json": 1684,
	"./por/home.json": 1685,
	"./por/marketplace.json": 1686,
	"./por/nft.json": 1687,
	"./por/pool.json": 1688,
	"./por/referral.json": 1689,
	"./por/swap.json": 1690,
	"./por/trading.json": 1691,
	"./por/vault.json": 1692,
	"./prs/common.json": 1693,
	"./prs/farm.json": 1694,
	"./prs/header.json": 1695,
	"./prs/home.json": 1696,
	"./prs/marketplace.json": 1697,
	"./prs/nft.json": 1698,
	"./prs/pool.json": 1699,
	"./prs/referral.json": 1700,
	"./prs/swap.json": 1701,
	"./prs/trading.json": 1702,
	"./rn/common.json": 1703,
	"./rn/farm.json": 1704,
	"./rn/header.json": 1705,
	"./rn/home.json": 1706,
	"./rn/marketplace.json": 1707,
	"./rn/nft.json": 1708,
	"./rn/pool.json": 1709,
	"./rn/referral.json": 1710,
	"./rn/swap.json": 1711,
	"./rn/trading.json": 1712,
	"./sp/common.json": 1713,
	"./sp/farm.json": 1714,
	"./sp/header.json": 1715,
	"./sp/home.json": 1716,
	"./sp/marketplace.json": 1717,
	"./sp/nft.json": 1718,
	"./sp/pool.json": 1719,
	"./sp/referral.json": 1720,
	"./sp/swap.json": 1721,
	"./sp/trading.json": 1722,
	"./srb/common.json": 1723,
	"./srb/farm.json": 1724,
	"./srb/header.json": 1725,
	"./srb/home.json": 1726,
	"./srb/marketplace.json": 1727,
	"./srb/nft.json": 1728,
	"./srb/pool.json": 1729,
	"./srb/referral.json": 1730,
	"./srb/swap.json": 1731,
	"./srb/trading.json": 1732,
	"./vi/common.json": 1733,
	"./vi/farm.json": 1734,
	"./vi/header.json": 1735,
	"./vi/home.json": 1736,
	"./vi/marketpalce.json": 1737,
	"./vi/nft.json": 1738,
	"./vi/pool.json": 1739,
	"./vi/referral.json": 1740,
	"./vi/swap.json": 1741,
	"./vi/trading.json": 1742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1595;